import { render, staticRenderFns } from "./TheAdminSidebar.vue?vue&type=template&id=7da1d4c1&"
import script from "./TheAdminSidebar.vue?vue&type=script&lang=js&"
export * from "./TheAdminSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports